import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import './App.css';

// WEBSITE COMPONENTS
import Dashboard from './dashboard/pages/Dashboard.js';
import Login from './dashboard/pages/Login';
import Signup from './dashboard/pages/Signup';
import Campaigns from './dashboard/pages/Campaigns';
import FaqPage from './dashboard/pages/Faqs';
import Mailing from './dashboard/pages/MailingLists';
import Notifications from './dashboard/pages/Notifications';
import Users from './dashboard/pages/Users';
import Admins from './dashboard/pages/Admins';
import ProductsPage from './dashboard/pages/Products.js';
import ProtectedRoute from './protectedRoute.js';

function App() {


  return (

      <Router>
        <Routes>
          <Route exact path="/" element={<Dashboard/>}></Route>
          <Route exact path="/dashboard" element={<Dashboard/>}></Route>
          <Route exact path="/login" element={<Login/>}></Route>
          <Route exact path="/it-admin-signup" element={<Signup/>}></Route>
          <Route exact path="/notifications" element={<Notifications/>}></Route>
          <Route exact path="/admins" element={<ProtectedRoute> <Admins /> </ProtectedRoute>}></Route>
          <Route exact path="/users" element={<Users/>}></Route>
          <Route exact path="/mailing-list" element={<Mailing/>}></Route>
          <Route exact path="/campaigns" element={<Campaigns/>}></Route>
          <Route exact path="/products" element={<ProductsPage/>}></Route>
          <Route exact path="/faqs" element={<FaqPage/>}></Route>
        </Routes>
      </Router>
  );
}

export default App;
